import { IHasLayout } from "../../Models/IHasLayout";
import { ComponentLayoutModel } from "./ComponentLayoutModel";

export function normalizeLayoutValue(value: unknown): string | number | undefined {
  if (typeof value === "number") {
    return `${value}px`;
  }

  if (typeof value === "string" && value.trim().length > 0) {
    const trimmedValue = value.trim();
    return /^-?\d+(\.\d+)?$/.test(trimmedValue) ? `${trimmedValue}px` : trimmedValue;
  }

  return undefined;
}

export default function getComponentLayout<T extends IHasLayout>(component: T): Record<string, any> {
  const componentLayout = component.Layout as ComponentLayoutModel;

  if (!componentLayout) {
    return {};
  }

  const componentLayoutSx = {
    height: normalizeLayoutValue(componentLayout?.Height),
    width: normalizeLayoutValue(componentLayout?.Width),
    minHeight: normalizeLayoutValue(componentLayout?.MinHeight),
    maxHeight: normalizeLayoutValue(componentLayout?.MaxHeight),
    minWidth: normalizeLayoutValue(componentLayout?.MinWidth),
    maxWidth: normalizeLayoutValue(componentLayout?.MaxWidth),

    color: componentLayout?.Color,
    backgroundColor: componentLayout?.BackgroundColor,
    fontWeight: componentLayout?.FontWeight,
    fontSize: normalizeLayoutValue(componentLayout?.FontSize),

    display: componentLayout?.Display,
    flexDirection: componentLayout?.FlexDirection,
    flex: componentLayout?.Flex,
    flexGrow: componentLayout?.FlexGrow,
    flexShrink: componentLayout?.FlexShrink,

    alignItems: componentLayout?.AlignItems,
    alignContent: componentLayout?.AlignContent,
    justifyContent: componentLayout?.JustifyContent,

    margin: normalizeLayoutValue(componentLayout?.Margin),
    marginTop: normalizeLayoutValue(componentLayout?.MarginTop),
    marginBottom: normalizeLayoutValue(componentLayout?.MarginBottom),
    marginLeft: normalizeLayoutValue(componentLayout?.MarginLeft),
    marginRight: normalizeLayoutValue(componentLayout?.MarginRight),

    padding: normalizeLayoutValue(componentLayout?.Padding),
    paddingTop: normalizeLayoutValue(componentLayout?.PaddingTop),
    paddingBottom: normalizeLayoutValue(componentLayout?.PaddingBottom),
    paddingLeft: normalizeLayoutValue(componentLayout?.PaddingLeft),
    paddingRight: normalizeLayoutValue(componentLayout?.PaddingRight),

    border: componentLayout?.Border,
    borderTop: componentLayout?.BorderTop,
    borderBottom: componentLayout?.BorderBottom,
    borderLeft: componentLayout?.BorderLeft,
    borderRight: componentLayout?.BorderRight,
    borderWidth: normalizeLayoutValue(componentLayout?.BorderWidth),
    borderStyle: componentLayout?.BorderStyle,
    borderColor: componentLayout?.BorderColor,
    borderRadius: componentLayout?.BorderRadius,
    boxShadow: componentLayout?.BoxShadow,
    overflow: componentLayout?.Overflow,
    overflowX: componentLayout?.OverflowX,
    overflowY: componentLayout?.OverflowY,

    whiteSpace: componentLayout?.WhiteSpace,
    opacity: componentLayout?.Opacity,
  };
  return componentLayoutSx;
}
